// Module
var code = "<td name=orders>{{ record.key | entityFormat }}</td> <td name=quantity>{{ getRemainingQuantity(record) }}</td> <td name=shipmentUnitProductQuantity>{{ getRemainingProductQuantity(record) }}</td> ";
// Exports
module.exports = code;